<div cdkDropList class="flex" [class.flex-col]="settings.displayMode === Axis2D.Vertical">
  <div cdkDrag *ngFor="let listItem of settings.listItems">
    {{ listItem }}
  </div>
</div>
